<template>
    <div>
        <el-dialog width="50%" @close="close" :visible.sync="dialogFormVisible">
            <div class="container">
                <div class="img">
                    <img src="../../assets/image/login/login.png" alt="" />
                    <div class="des">
                        <div style="margin-bottom: 10px">淮河能源控股集团</div>
                        <div>员工保障信息服务平台</div>
                    </div>
                </div>
                <div class="form">
                    <div style="padding: 30px 20px">
                        <el-divider><span style="font-size: 22px">请登录</span></el-divider>
                    </div>
                    <el-form :rules="rules" ref="form" label-position="left" :model="form">
                        <el-form-item label="身份证号" prop="card" :label-width="formLabelWidth">
                            <el-input v-model="form.card" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password" :label-width="formLabelWidth">
                            <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="authCodeImg" :label-width="formLabelWidth">
                            <div style="display:flex;align-items:center">
                                <el-input v-model="form.authCodeImg" autocomplete="off"></el-input>
                                <img :src="authCode" @click="getAuthCode" style="width: 60%" />
                            </div>
                        </el-form-item>
                    </el-form>
                    <div class="extra-bottom">
                        <div style="cursor: pointer" @click="toFindPassword">找回密码</div>
                        <div @click="toRegister" class="register">立即注册</div>
                    </div>
                    <div class="btn">
                        <el-button @click="login" type="primary">登录</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/api/loginAndRegister";
import md5 from "js-md5";
export default {
    data() {
        return {
            dialogFormVisible: false,
            form: {
                card: "",
                password: "",
                authCodeImg: "",
            },
            formLabelWidth: "95px",
            rules: {
                card: [{ required: true, message: "请输入身份证号码", trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                authCodeImg: [{ required: true, message: "请输入验证码", trigger: "blur" }],
            },
            authCode: "",
        };
    },
    watch: {
        loginVisible() {
            this.dialogFormVisible = this.loginVisible;
            if (this.loginVisible) {
                this.getAuthCode();
            }
        },
    },
    computed: {
        loginVisible() {
            return this.$store.state.loginVisible;
        },
    },
    mounted() {
        this.$store.commit("closeLogin");
    },
    methods: {
        toFindPassword() {
            this.$store.commit("closeLogin");
            setTimeout(() => {
                this.$store.commit("openFindPassword");
            }, 500);
        },
        async getAuthCode() {
            try {
                const res = await request.getAuthCode();
                console.log("res", res);
                this.authCode = "data:image/png;base64," + res.imagebase64;
                this.form.authCodeImg = "";
            } catch (error) {
                console.log("error", error);
            }
        },
        close() {
            this.$store.commit("closeLogin");
            this.$refs.form.resetFields();
        },
        /* 登录 */
        login() {
            this.$refs.form.validate(async (valid) => {
                const regex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[`~!@#$%^&*()\-_+=,./<>?])[\da-zA-Z`~!@#$%^&*()\-_+=,./<>?]{10,18}$/;
                const para = {
                    userid: this.form.card,
                    passwd: md5(md5(this.form.password)),
                    validateCode: "1",
                    authCodeImg: this.form.authCodeImg,
                };
                if (valid) {
                    try {
                        //调接口，判断密码是否正确，是否长时间未更改密码
                        const data = await request.checkUser(para);
                        const lnl = data.lnl; // 是否长时间未更改密码
                        //密码正确，若为弱密码，强制修改密码
                        if (!regex.test(this.form.password)) {
                            this.$confirm("您的密码强度较弱，为了您的账号安全，请修改密码!", "提示", {
                                confirmButtonText: "确定",
                                showCancelButton: false,
                                showClose: false,
                                closeOnPressEscape: false,
                                type: "warning",
                            }).then(() => {
                                this.$store.commit("closeLogin");
                                this.$store.commit("openModifyPwd");
                            });       
                        } else if (lnl === 'true') {
                            this.$confirm("您当前账号密码使用已经超过6个月，为了您的账号安全，请修改密码！", "提示", {
                                confirmButtonText: "确定",
                                showCancelButton: false,
                                showClose: false,
                                closeOnPressEscape: false,
                                type: "warning",
                            }).then(() => {
                                this.$store.commit("closeLogin");
                                this.$store.commit("openModifyPwd");
                            });
                        }else {
                            try {
                                const data = await request.login(para);
                                sessionStorage.setItem("__usersession_uuid", data.__usersession_uuid);
                                this.$store.commit("setUserInfo", data);
                                sessionStorage.setItem("userInfo", JSON.stringify(data));
                                this.$message({
                                    type: "success",
                                    message: "登录成功",
                                });
                                this.$store.commit("closeLogin");
                                this.$router.push("/home");
                            } catch (error) {
                                this.getAuthCode();
                            }
                        }
                        console.log('data>>>>', data);
                    } catch (error) {
                        this.getAuthCode();
                    }
                    
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        toRegister() {
            this.$store.commit("closeLogin");
            setTimeout(() => {
                this.$store.commit("openRegister");
            }, 500);
        },
    },
};
</script>

<style scoped lang="scss">
.container {
    display: flex;
    .img {
        width: 50%;
        height: 440px;
        position: relative;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .des {
        position: absolute;
        top: 40%;
        // left: 15%;
        width: 100%;
        font-weight: 700;
        text-align: center;
        color: #fff;
        font-size: 30px;
    }
    .form {
        width: 40%;
        padding: 30px 30px 30px 40px;
    }
    .extra-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #2a8ae0;
        font-size: 15px;
        margin-bottom: 40px;
    }
    .register {
        cursor: pointer;
    }
    .btn {
        width: 100%;
    }
}
::v-deep .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
::v-deep .el-dialog__header {
    padding: 0px 20px 0px;
}
.el-button--medium {
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 4px;
    width: 100%;
}
</style>
